import { RiBracesLine } from '@remixicon/react';
import type { ReactNode } from 'react';

import { Column, Container } from '@playbook/modules/layout';

import { MethodBadge } from '@portal/views/_shared/method-badge';

import css from './styles.module.css';

interface ReferenceHeadingProps {
	method: string;
	endpoint: string;
	group?: string;

	children: ReactNode;
}

export function ReferenceHeading({
	method,
	endpoint,
	group,

	children,
}: ReferenceHeadingProps): ReactNode {
	return (
		<Container name="referenceHeading" className={css.heading}>
			<Column spacing={4} className={css.header}>
				{group && (
					<span className={css.group}>
						<RiBracesLine /> {group}
					</span>
				)}
				<h1>{children}</h1>
				<span className={css.endpoint}>
					<MethodBadge method={method} tint="filled" />
					<code className={css.path}>{endpoint}</code>
				</span>
			</Column>
		</Container>
	);
}
